import $request from '../../utils/request';
var state = {
    usernameZh: '',
    featureList: [],
    leftMenuList: [],
    topMenuList: [],
    btnMenuList: [],
    openMenu: '',
    activeMenu: '',
    token: '',
    activeIndex: {},
};
var getters = {};
var actions = {
    GET_MENU_LIST: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        if (params === void 0) { params = { this_: null }; }
        commit('update', {
            leftMenuList: [],
            topMenuList: [],
            btnMenuList: [],
        });
        var this_ = params.this_;
        $request({
            method: 'post',
            url: '/proxy/resource/resource/accessible',
            data: {},
        }).then(function (res) {
            if (!res.errorCode) {
                var list_1 = res.data;
                var leftMenuList_1 = [];
                var topMenuList_1 = [];
                var btnMenuList_1 = [];
                var activeIndex = {};
                var compare_1 = function (proto) { return function (item1, item2) { return item1[proto] - item2[proto]; }; };
                var filterChild_1 = function (parentFeatures) {
                    if (!parentFeatures)
                        return;
                    parentFeatures.forEach(function (p) {
                        p.children = list_1.filter(function (f) {
                            return f.parentCode === p.resourceCode;
                        });
                        p.children.sort(compare_1('serialNo'));
                        filterChild_1(p.children);
                    });
                };
                list_1.forEach(function (item) {
                    var type = item.type, parentCode = item.parentCode;
                    if (parentCode === '') {
                        filterChild_1([item]);
                        if (type === 'LEFT_MENU' || type === 'PERMANENT') {
                            item.status = true;
                            leftMenuList_1.push(item);
                            return;
                        }
                        if (type === 'TOP_MENU') {
                            topMenuList_1.push(item);
                            return;
                        }
                        if (type === 'BUTTON') {
                            btnMenuList_1.push(item);
                        }
                    }
                });
                for (var i = 0; i < leftMenuList_1.length; i++) {
                    activeIndex[i] = false;
                }
                leftMenuList_1.sort(compare_1('serialNo'));
                topMenuList_1.sort(compare_1('serialNo'));
                commit('update', {
                    usernameZh: '',
                    username: 'zhangqi',
                    leftMenuList: leftMenuList_1,
                    topMenuList: topMenuList_1,
                    btnMenuList: btnMenuList_1,
                    activeIndex: activeIndex,
                    featureList: list_1,
                });
                return;
            }
            if (this_) {
                this_.$message.error('请联系管理员添加菜单权限');
                setTimeout(function () {
                    window.location.href = '/';
                }, 1000);
            }
        });
    },
};
var mutations = {
    update: function (state, props) {
        for (var key in props) {
            if (state.hasOwnProperty(key)) {
                state[key] = props[key];
            }
        }
    },
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};
